import { ChangeDetectionStrategy, Component, HostBinding, Input, computed, inject, input, signal } from '@angular/core';

import { RxStrategyProvider } from '@rx-angular/cdk/render-strategies';
import { Subject, map, startWith } from 'rxjs';

import { PodType, TopEventsPodData } from '../top-events.model';

@Component({
    selector: 'ms-top-events-pod',
    templateUrl: './top-events-pod.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TopEventsPodComponent {
    @HostBinding('class') className = 'pod';
    @Input() index: number;
    pod = input.required<TopEventsPodData>();

    private strategy = inject(RxStrategyProvider);

    readonly toggleExpanded = signal<boolean | undefined>(undefined);
    readonly hasMetaData = computed(() => {
        const pod = this.pod();
        if (pod.metaData) {
            return true;
        } else if (!pod.hideMetadataFallback) {
            if ([PodType.BetBuilder, PodType.HandpickedOptionsPod].includes(pod.podType) && pod.events?.length === 1) {
                return true;
            } else if (pod.podType === PodType.Single) {
                return !!pod.events[0];
            }
        }

        return false;
    });

    private isExpanded(pod: TopEventsPodData, userSet?: boolean): boolean {
        if (userSet !== undefined) {
            return userSet;
        }
        if (pod.hidePodHeader) {
            return true;
        }

        return pod.isExpanded;
    }

    readonly headerPod = computed(() => {
        const pod = this.pod();
        return { ...pod, isExpanded: this.isExpanded(pod, this.toggleExpanded()) };
    });

    readonly render$ = new Subject();
    readonly renderStrategy$ = this.render$.pipe(
        map(() => this.strategy.primaryStrategy),
        startWith('native'),
    );
}
